import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export const IconList = ({ node })=> {
    return (
        <ul>
            {node.map((icon, idx)=> (
                <li key={idx} >
                    <GatsbyImage
                        image={getImage(
                            icon.relationships?.field_icon_img.relationships
                                ?.field_media_image?.localFile
                        )}
                        alt={
                            icon.relationships?.field_icon_img
                                ?.field_media_image?.alt ?? ``}
                    />
                    <div
                        className="icon-text"
                        dangerouslySetInnerHTML={{ __html: icon.field_content_text?.value }}
                    ></div>
                </li>
            ))}
        </ul>
    );
}